export default {
  SET_DISPLAY_CHOOSE_LANGUAGE_DIALOG_STATUS:
    'SET_DISPLAY_CHOOSE_LANGUAGE_DIALOG_STATUS',
  SET_LOCALE: 'SET_LOCALE',
}
